import { Box, Button, Text, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const NoDataMessage = () => {
    const navigate = useNavigate();
  return (
    <Box
      w="100%"
      h="70%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={4}
      py={8}
    >
      <VStack spacing={2} textAlign="center">
        <Text fontSize="xl" fontWeight="bold">
          You haven’t used this feature yet.
        </Text>
        <Text fontSize="md" color="gray.500">
          Use the platform to generate your activity — your results will appear
          here
        </Text>
        <Button colorScheme="blue" onClick={() => navigate("/Agent-Generation")}>
          Go to Home
        </Button>
      </VStack>
    </Box>
  );
};

export default NoDataMessage;
